<template>
  <div class="callout border-top border-bottom text-center p-lgp mt-lgp mx-auto">
    <div class="d-flex flex-wrap justify-content-center gap-md-xxs text-pewter">
      <p class="bold mb-0">
        {{ title }}
      </p>
      <p class="mb-0">
        {{ subtitle }}
      </p>
    </div>
  </div>
</template>

<script setup>
defineProps({
  title: {
    type: String,
    required: true
  },
  subtitle: {
    type: String,
    required: true
  }
})
</script>

<style lang="scss" scoped>
.callout {
  width: 90%;
}
</style>